class Project {
    constructor() {
    }

    static get_form() {
        return {
            name: null,
            picture: null,
            advancement: 0,
            description: null,
            deadline: null,
            status: "in_progress",
            priority: "weak"
        }
    }

    static get_status() {
        return [
            {value: "in_progress", text: "En cours"},
            {value: "ended", text: "Terminé"},
            {value: "canceled", text: "Annulé"},
        ]
    }

    static get_late_status() {
        return [
            {value: "right_track", text: "En bonne voie"},
            {value: "at_risk", text: "À risque"},
            {value: "wrong_track", text: "En mauvaise voie"},
        ]
    }

    static get_priority_choices(){
        return [
            {text: "Priorité faible", value: "weak"},
            {text: "Priorité moyenne", value: "medium"},
            {text: "Priorité forte", value: "strong"},
        ]
    }
}

class Step {
    constructor() {
    }

    static get_form() {
        return {
            project: null,
            order: 0,
            name: null,
            label: null,
        }
    }
}

class Task {
    constructor() {
    }

    static get_form() {
        return {
            title: null,
            description: null,
            step: null,
            deadline: null,
            start: null,
            labels: [],
            assigned_users: [],
            to_do_list: null,
            priority: "weak",
            topics: [],
            late_management: false,
            at_risk: 0,
            wrong_way: 0
        }
    }


    static get_priority_choices() {
        return [
            {text: "Priorité faible", value: "weak"},
            {text: "Priorité moyenne", value: "medium"},
            {text: "Priorité forte", value: "strong"},
        ]
    }
}

class LabelProject {
    constructor() {
    }

    static get_form() {
        return {
            name: null,
            color: Math.floor(Math.random() * 16777215).toString(16),
        }
    }
}

class ToDoList {
    constructor() {
    }

    static get_form() {
        return {
            name: null,
        }
    }
}

class ToDoStates {
    constructor() {
    }

    static get_form() {
        return {
            assigned_users: [],
            is_done: false,
            name: null,
            deadline: null,
            to_do_list: null,
        }
    }
}

class Comment {
    constructor() {
    }

    static get_form() {
        return {
            assigned_users: [],
            message: null,
            task: null,
        }
    }
}

class Topic {
    constructor() {
    }

    static get_form() {
        return {
            deadline: null,
            description: null,
            name: null,
            tasks: [],
            late_management: null,
            at_risk: 0,
            wrong_way: 0,
        }
    }
}

class Workload {
    constructor() {
    }

    static get_form() {
        return {
            normal: 5,
            under_charge: 2,
            project: null
        }
    }
}

class DashboardProject{
    constructor() {
    }

    static get_filters(){
        return{
            projects: {
                filters: {
                    project__canceled: {
                        label: "Projets annulés",
                        value: false,
                    },
                    project__in_progress: {
                        label: "Projets en cours",
                        value: false,
                    },
                    project__ended: {
                        label: "Projets terminés",
                        value: false,
                    },
                    project__status: {
                        label: "Status des projets",
                        value: false,
                    }
                },
                label: "Projets"
            },
            tasks: {
                filters: {
                    task__deadline_today: {
                        label: "Tâches arrivant à échéance aujourd'hui",
                        value: false
                    },
                    task__deadline_week: {
                        label: "Tâches arrivant à échéance cette semaine",
                        value: false
                    }
                },
                label: 'Tâches'
            }
        }
    }

}

module.exports.Project = Project;
module.exports.Step = Step;
module.exports.Task = Task;
module.exports.LabelProject = LabelProject;
module.exports.ToDoList = ToDoList;
module.exports.ToDoStates = ToDoStates;
module.exports.Comment = Comment;
module.exports.Topic = Topic;
module.exports.Workload = Workload;
module.exports.DashboardProject = DashboardProject;